import React, { useCallback } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';

import * as routes from 'pages/routes';

import { ErrorIllustration } from 'public/illustrations';

import * as userResource from 'resources/user/hooks';

import Button from 'components/UI/Button';

import MainLayout from 'pages/_app/PageConfig/MainLayout';
import UnauthorizedLayout from 'pages/_app/PageConfig/UnauthorizedLayout';

import styles from './styles.module.css';

const ErrorPage = () => {
  const router = useRouter();

  const { data: user } = userResource.useCurrentUser();

  const onRedirectToHome = useCallback(() => {
    router.push(routes.path.home);
  }, [router]);

  const Layout = user ? MainLayout : UnauthorizedLayout;

  return (
    <Layout>
      <Head>
        <title>404</title>
      </Head>
      <div className={styles.container}>
        <ErrorIllustration />

        <p className={styles.title}>Uh oh,  we can’t find that page.</p>
        <p className={styles.text}>404 Error - page not found</p>
        <Button
          className={styles.goHome}
          onClick={onRedirectToHome}
        >
          Back to home
        </Button>
      </div>
    </Layout>
  );
};

export default React.memo(ErrorPage);
